"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcessDurationMins = void 0;
function getProcessDurationMins(start, end) {
    // nanoseconds to milliseconds
    const startTime = new Date(Number(start) / 1000000);
    const endTime = new Date(Number(end) / 1000000);
    // To minutes
    return Math.abs((startTime.getTime() - endTime.getTime()) / (1000 * 60));
}
exports.getProcessDurationMins = getProcessDurationMins;
//# sourceMappingURL=process.js.map